// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.landlord.v1.CappsLandlordPropertyDetailsWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsLandlordPropertyDetailsWebApiHandler_autocomplete,
  CappsLandlordPropertyDetailsWebApiHandler_autocomplete_Path,
  CappsLandlordPropertyDetailsWebApiHandler_details,
  CappsLandlordPropertyDetailsWebApiHandler_details_Path,
  CappsLandlordPropertyDetailsWebApiHandler_getWebAnalytics,
  CappsLandlordPropertyDetailsWebApiHandler_getWebAnalytics_Path,
  CappsLandlordPropertyDetailsWebApiHandler_isListingPresent,
  CappsLandlordPropertyDetailsWebApiHandler_isListingPresent_Path,
  CappsLandlordPropertyDetailsWebApiHandler_updateApplicationsAccepted,
} from '@zg-rentals/ts-capps-client';

import type {
  AddressAutocompleteWebResponseDto,
  ListingAlias,
  PropertyDetailsResponseDto,
  UpdateApplicationsAcceptedRequestDto,
  WebAnalyticsWebApiResponseDto,
} from '@zg-rentals/ts-capps-client';

interface AutocompleteParams {
  partialAddress: string;
}
interface DetailsParams {
  listingAlias: ListingAlias;
}
interface GetWebAnalyticsParams {
  listingAlias: ListingAlias;
}
interface IsListingPresentParams {
  listingAlias: ListingAlias;
}

export type CappsLandlordPropertyDetailsWebApiHandler_autocomplete_Options = UseQueryOptions<
  AddressAutocompleteWebResponseDto,
  unknown,
  AddressAutocompleteWebResponseDto,
  readonly [string, AutocompleteParams]
>;

const CappsLandlordPropertyDetailsWebApiHandler_autocomplete_GetKey = (getParams: AutocompleteParams) =>
  [CappsLandlordPropertyDetailsWebApiHandler_autocomplete_Path, getParams] as const;

export const CappsLandlordPropertyDetailsWebApiHandler_autocomplete_queryOptions = (
  getParams: AutocompleteParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsLandlordPropertyDetailsWebApiHandler_autocomplete_GetKey(getParams),
    queryFn: () => CappsLandlordPropertyDetailsWebApiHandler_autocomplete(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get autocomplete addresses for a partial address
 */
export const useCappsLandlordPropertyDetailsWebApiHandler_autocomplete = (
  getParams: AutocompleteParams,
  {
    httpClient,
    ...options
  }: Omit<CappsLandlordPropertyDetailsWebApiHandler_autocomplete_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsLandlordPropertyDetailsWebApiHandler_autocomplete_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsLandlordPropertyDetailsWebApiHandler_autocomplete.getKey =
  CappsLandlordPropertyDetailsWebApiHandler_autocomplete_GetKey;

export type CappsLandlordPropertyDetailsWebApiHandler_details_Options = UseQueryOptions<
  PropertyDetailsResponseDto,
  unknown,
  PropertyDetailsResponseDto,
  readonly [string, DetailsParams]
>;

const CappsLandlordPropertyDetailsWebApiHandler_details_GetKey = (getParams: DetailsParams) =>
  [CappsLandlordPropertyDetailsWebApiHandler_details_Path, getParams] as const;

export const CappsLandlordPropertyDetailsWebApiHandler_details_queryOptions = (
  getParams: DetailsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsLandlordPropertyDetailsWebApiHandler_details_GetKey(getParams),
    queryFn: () => CappsLandlordPropertyDetailsWebApiHandler_details(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsLandlordPropertyDetailsWebApiHandler_details = (
  getParams: DetailsParams,
  {
    httpClient,
    ...options
  }: Omit<CappsLandlordPropertyDetailsWebApiHandler_details_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsLandlordPropertyDetailsWebApiHandler_details_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsLandlordPropertyDetailsWebApiHandler_details.getKey = CappsLandlordPropertyDetailsWebApiHandler_details_GetKey;

export type CappsLandlordPropertyDetailsWebApiHandler_getWebAnalytics_Options = UseQueryOptions<
  WebAnalyticsWebApiResponseDto,
  unknown,
  WebAnalyticsWebApiResponseDto,
  readonly [string, GetWebAnalyticsParams]
>;

const CappsLandlordPropertyDetailsWebApiHandler_getWebAnalytics_GetKey = (getParams: GetWebAnalyticsParams) =>
  [CappsLandlordPropertyDetailsWebApiHandler_getWebAnalytics_Path, getParams] as const;

export const CappsLandlordPropertyDetailsWebApiHandler_getWebAnalytics_queryOptions = (
  getParams: GetWebAnalyticsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsLandlordPropertyDetailsWebApiHandler_getWebAnalytics_GetKey(getParams),
    queryFn: () => CappsLandlordPropertyDetailsWebApiHandler_getWebAnalytics(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get listing web analytics data
 */
export const useCappsLandlordPropertyDetailsWebApiHandler_getWebAnalytics = (
  getParams: GetWebAnalyticsParams,
  {
    httpClient,
    ...options
  }: Omit<CappsLandlordPropertyDetailsWebApiHandler_getWebAnalytics_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsLandlordPropertyDetailsWebApiHandler_getWebAnalytics_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsLandlordPropertyDetailsWebApiHandler_getWebAnalytics.getKey =
  CappsLandlordPropertyDetailsWebApiHandler_getWebAnalytics_GetKey;

export type CappsLandlordPropertyDetailsWebApiHandler_isListingPresent_Options = UseQueryOptions<
  boolean,
  unknown,
  boolean,
  readonly [string, IsListingPresentParams]
>;

const CappsLandlordPropertyDetailsWebApiHandler_isListingPresent_GetKey = (getParams: IsListingPresentParams) =>
  [CappsLandlordPropertyDetailsWebApiHandler_isListingPresent_Path, getParams] as const;

export const CappsLandlordPropertyDetailsWebApiHandler_isListingPresent_queryOptions = (
  getParams: IsListingPresentParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsLandlordPropertyDetailsWebApiHandler_isListingPresent_GetKey(getParams),
    queryFn: () => CappsLandlordPropertyDetailsWebApiHandler_isListingPresent(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsLandlordPropertyDetailsWebApiHandler_isListingPresent = (
  getParams: IsListingPresentParams,
  {
    httpClient,
    ...options
  }: Omit<CappsLandlordPropertyDetailsWebApiHandler_isListingPresent_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsLandlordPropertyDetailsWebApiHandler_isListingPresent_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsLandlordPropertyDetailsWebApiHandler_isListingPresent.getKey =
  CappsLandlordPropertyDetailsWebApiHandler_isListingPresent_GetKey;

export interface CappsLandlordPropertyDetailsWebApiHandler_updateApplicationsAccepted_Args {
  postData: UpdateApplicationsAcceptedRequestDto;
}

export type CappsLandlordPropertyDetailsWebApiHandler_updateApplicationsAccepted_Options = UseMutationOptions<
  void,
  unknown,
  CappsLandlordPropertyDetailsWebApiHandler_updateApplicationsAccepted_Args
>;

export const useCappsLandlordPropertyDetailsWebApiHandler_updateApplicationsAccepted = ({
  httpClient,
  ...options
}: Omit<CappsLandlordPropertyDetailsWebApiHandler_updateApplicationsAccepted_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsLandlordPropertyDetailsWebApiHandler_updateApplicationsAccepted_Args) =>
      CappsLandlordPropertyDetailsWebApiHandler_updateApplicationsAccepted(args.postData, httpClient),
  });
};
